import { useEffect, useState } from 'react'

export const WIDE = '(min-width: 48.0625rem)'

export function useDrawer() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const wide = window.matchMedia(WIDE)
    const settle = () => {
      if (wide.matches) setOpen(false)
    }

    wide.addEventListener('change', settle)

    return () => wide.removeEventListener('change', settle)
  }, [])

  return { open, setOpen, show: () => setOpen(true), close: () => setOpen(false) }
}
